import { Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStationStatus } from '@models/chargingStationStatus';
import { ChargingPowerProfile } from '@models/chargingPowerProfile';
import { ChargingStationsService } from '@services/entity/charging-stations.service';

@Component({
  selector: 'transaction-status-badge',
  templateUrl: './transaction-status-badge.component.html',
  styleUrls: ['./transaction-status-badge.component.scss'],
})
export class TransactionStatusBadge implements OnInit {

  public className: string;

  public caption: string
  public tooltip: string
  @Input() status: ChargingStationStatus
  @Input() isCaptioned: boolean = true
  @Input() profile: ChargingPowerProfile
  @Input() isShowingProfile: boolean = true

  constructor( ) {  }

  ngOnInit(): void {
    this.setToolTip()
  }
  ngOnChanges(): void {
    this.setToolTip()
  }

  setToolTip(): void {
    this.tooltip = ChargingStationsService.mapStatusTooltip(this.status?.id)
  }
}
